module.exports = __webpack_public_path__ + "static/media/ico_temp.5aecf3ba.svg";